export default __webpack_public_path__ + "static/media/screen6.3d7b34ba.jpg";